import { render, staticRenderFns } from "./Search.vue?vue&type=template&id=208c00fe"
import script from "./Search.vue?vue&type=script&lang=js"
export * from "./Search.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ProductCard: require('/opt/build/repo/components/product/Card.vue').default,PageEshopProducts: require('/opt/build/repo/node_modules/@evince/eshop/lib/templates/Products.vue').default,CategoryCarousel: require('/opt/build/repo/components/category/Carousel.vue').default,SectionOffers: require('/opt/build/repo/components/section/Offers.vue').default})
